<base-section [index]="index" [section]="section">
  <div class="grid grid-cols-2 itineraire-container" #itineraireContainer>
    <div class="map-container" #itineraireMapContainer>
      <synapi-map #map
                  [waypoints]="waypoints"
                  (onDistanceChange)="onDistanceChange($event)"
                  (onDurationChange)="onDurationChange($event)"
                  (onPredicateChange)="onPredicateChange($event)"
                  *ngIf="waypoints.length>0"
                  [isItineraire]="true"
                  [profiles]="sectionRendered.vehicules"
                  [defaultProfile]="sectionRendered.vehicule_default"
                  [predicate]="mapPredicate"
                  [items]="mapItems.items"
      ></synapi-map>
    </div>
    <div class="itineraire-content" #itineraireContent>
      <div class="itineraire-informations">
        <div class="itineraire-information">
          <i class="lvi-thel-etapes"></i>
          <span>{{ sectionRendered.fiches.length }} étapes</span>
        </div>
        <div class="itineraire-information">
          <i class="lvi-thel-distance"></i>
          <span>{{ distance }}</span>
        </div>
        <div class="itineraire-information">
          <i class="lvi-thel-duree"></i>
          <span>{{ duration }}</span>
        </div>
      </div>
      <div class="itineraire-places">
        <div id="Waypoint{{i}}" class="itineraire-place" *ngFor="let step of sectionRendered.fiches; let i = index;">
          <a [routerLink]="(step.fiche.item ? ['/fiche',step.fiche.item.Slug+'-'+step.fiche.item.ExternalId] : [])" target="_blank" class="place-top reverse">
            <media-attachment [forceBackground]="true" [attachment]="step.fiche.fond|attachmentFromId|async" [sizeXL]="10" [sizeLG]="10" [sizeMD]="10" [sizeSM]="10" [sizeXS]="10" class="place-background" *ngIf="step.fiche.fond"></media-attachment>
            <media-attachment [forceBackground]="true" [alt]="step.title" [sizeXL]="10" [sizeLG]="10" [sizeMD]="10" [sizeSM]="10" [sizeXS]="10" class="place-background" [url]="step.fiche.item.ImageUrl"  *ngIf="!step.fiche.fond && step.fiche.item?.ImageUrl"></media-attachment>
            <div class="place-top-left">
              <div class="place-title-container">
                <div class="place-index">
                  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M30 3.75C24.5318 3.7562 19.2894 5.93118 15.4228 9.79777C11.5562 13.6644 9.3812 18.9068 9.375 24.375C9.375 42.0234 28.125 55.3523 28.9242 55.9102C29.2395 56.131 29.6151 56.2495 30 56.2495C30.3849 56.2495 30.7605 56.131 31.0758 55.9102C31.875 55.3523 50.625 42.0234 50.625 24.375C50.6188 18.9068 48.4438 13.6644 44.5772 9.79777C40.7106 5.93118 35.4682 3.7562 30 3.75ZM30 16.875C31.4834 16.875 32.9334 17.3149 34.1668 18.139C35.4001 18.9631 36.3614 20.1344 36.9291 21.5049C37.4968 22.8753 37.6453 24.3833 37.3559 25.8382C37.0665 27.293 36.3522 28.6294 35.3033 29.6783C34.2544 30.7272 32.918 31.4415 31.4632 31.7309C30.0083 32.0203 28.5003 31.8718 27.1299 31.3041C25.7594 30.7364 24.5881 29.7751 23.764 28.5418C22.9399 27.3084 22.5 25.8584 22.5 24.375C22.5 22.3859 23.2902 20.4782 24.6967 19.0717C26.1032 17.6652 28.0109 16.875 30 16.875Z" fill="#FFA553"/>
                    <circle cx="30" cy="25" r="15" fill="white"/>
                    <text x="30" y="30" text-anchor="middle" fill="#333" font-weight="700">{{ i+1 }}</text>
                  </svg>
                </div>
                <div class="place-title-inner">
                  <div class="place-title h5">{{ step.title }}</div>
                  <div class="place-city" *ngIf="step.fiche.item?.AdressePrincipale">{{ step.fiche.item.AdressePrincipale.Commune }}</div>
                </div>
              </div>
              <div class="place-description" *ngIf="step.fiche.description" [innerHTML]="step.fiche.description">
              </div>
              <div class="place-description" *ngIf="!step.fiche.description && step.fiche.item?.ShortDesc" [innerHTML]="step.fiche.item.ShortDesc">
              </div>
            </div>
            <div class="place-top-right">
              <div class="place-image-container" *ngIf="step.fiche.item?.ImageUrl">
                <media-attachment [forceBackground]="true" [alt]="step.title" [sizeXL]="10" [sizeLG]="10" [sizeMD]="10" [sizeSM]="10" [sizeXS]="10" class="place-image" [url]="step.fiche.item.ImageUrl"  ></media-attachment>
              </div>
            </div>
          </a>
          <div class="place-bottom" *ngIf="step.fiche.informations || step.fiche.around || step.fiche.on_the_road">
            <ul class="place-tabs">
              <li *ngIf="step.fiche.informations" i18n="@@Infos" [ngClass]="{'active':step.fiche.isTabInformations}" (click)="onPlaceTabClick(step.fiche,'isTabInformations')">
                Infos
              </li>
              <li *ngIf="step.fiche.around" i18n="@@DoAround" [ngClass]="{'active':step.fiche.isTabAround}" (click)="onPlaceTabClick(step.fiche,'isTabAround')">
                A faire autour
              </li>
              <li *ngIf="step.fiche.on_the_road" i18n="@@OnTheRoad" [ngClass]="{'active':step.fiche.isTabOnTheRoad}" (click)="onPlaceTabClick(step.fiche,'isTabOnTheRoad')">
                Sur la route
              </li>
            </ul>
            <div class="place-tab" *ngIf="step.fiche.informations && step.fiche.isTabInformations" [innerHTML]="step.fiche.informations"></div>
            <div class="place-tab" *ngIf="step.fiche.around && step.fiche.isTabAround" [innerHTML]="step.fiche.around"></div>
            <div class="place-tab" *ngIf="step.fiche.on_the_road && step.fiche.isTabOnTheRoad" [innerHTML]="step.fiche.on_the_road"></div>
          </div>
        </div>
        <div class="list-container col-span-1" id="AroundTheRoad">
          <div class="h2 mt-3" i18n="@@AroundTheRoad">Autour de la route</div>
          <synapi-list-items  [pagecountMax]="200" [col]="3" [size]="9"  #list></synapi-list-items>
        </div>
      </div>
    </div>

  </div>
</base-section>
